// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"styles_videoWrapper__CXpRU","videoOverlay":"styles_videoOverlay__HQ7TI","playButton":"styles_playButton__Tqlli"};